module.exports = new __parcel__URL__("whale02.34ed0d5f.png").toString();